export default "__VITE_ASSET__71856b5a__"